import { createAction, props } from '@ngrx/store';

import { AuthCookieInterface } from './auth-admin.state';
import {
  AuthUserEntityInterface,
  LoginInterface,
  ResponseLoginInterface,
} from '../../interfaces/auth.interface';
import { ErrorInterface } from '../../interfaces/general.interface';

enum AuthActionType {
  AuthInit = '[Auth Admin] Init Auth',
  AuthInitSet = '[Auth Admin] Init Auth SET',
  LoginLoading = '[Auth Admin] Login',
  RefreshTokenLoading = '[Auth Admin] Refresh Token',
  LoginSuccess = '[Auth Admin] Login Success',
  LoginSuccessCookiesSet = '[Auth Admin] Login Success Cookies Set',
  LoginFailure = '[Auth Admin] Login Failure',
  LogoutLoading = '[Auth Admin] Logout',
  DeleteCookiesLoading = '[Auth Admin] Delete Cookies',
  DeleteCookiesSuccessLoading = '[Auth Admin] Delete Cookies Success',
  DeleteLoading = '[Auth Admin] Delete',
}

export const logoutAdmin = createAction(AuthActionType.LogoutLoading);

export const refreshTokenLoading = createAction(
  AuthActionType.RefreshTokenLoading,
  props<{ refreshToken: string }>()
);

export const DeleteCookiesLoadingAdmin = createAction(
  AuthActionType.DeleteCookiesLoading
);

export const DeleteCookiesSuccessLoadingAdmin = createAction(
  AuthActionType.DeleteCookiesSuccessLoading
);

export const InitAuthAdmin = createAction(AuthActionType.AuthInit);

export const InitAuthSetAdmin = createAction(
  AuthActionType.AuthInitSet,
  props<{ entity: AuthCookieInterface | null }>()
);

export const loginAdmin = createAction(
  AuthActionType.LoginLoading,
  props<{ params: LoginInterface }>()
);

export const loginAdminSuccessCookiesSet = createAction(
  AuthActionType.LoginSuccessCookiesSet,
  props<{ params: ResponseLoginInterface }>()
);

export const loginAdminSuccess = createAction(
  AuthActionType.LoginSuccess,
  props<{ response: ResponseLoginInterface }>()
);

export const loginAdminFailure = createAction(
  AuthActionType.LoginFailure,
  props<{ error: ErrorInterface }>()
);

export const setLocalstorageAdmin = createAction(
  AuthActionType.LoginFailure,
  props<{ auth: AuthUserEntityInterface }>()
);
